/**
 * Site-wide constants: identity, navigation, contacts, SEO defaults.
 */

export const site = {
  name: 'StudyLabPro',
  title: 'StudyLabPro — Independent AI-first R&D Laboratory',
  tagline: 'Independent AI-first R&D Laboratory',
  description:
    'StudyLabPro is a living artificial-intelligence laboratory: agent-native runtimes, knowledge graphs, the adaptive learning platform behind StudyNinja, and numerical foundations — research that ships to production.',
  origin: process.env.SITE_ORIGIN ?? 'https://studylabpro.com',
  github: 'https://github.com/StudyLabPro',
  email: 'andrew@xteam.pro',
  commercialArm: { name: 'XTeam.Pro', href: 'https://www.xteam.pro' },
  product: { name: 'StudyNinja', href: 'https://studyninja.ru' },
} as const;

/** `key` indexes dict.nav for the localized label; `label` is the English fallback. */
export type NavKey =
  | 'command'
  | 'anu'
  | 'research'
  | 'projects'
  | 'agents'
  | 'knowledge'
  | 'publications'
  | 'observatory'
  | 'about'
  | 'contact';

export interface NavItem {
  key: NavKey;
  label: string;
  href: string;
  zone?: import('../lab/types').ZoneId;
}

export const primaryNav: NavItem[] = [
  { key: 'research', label: 'Research', href: '/research', zone: 'research' },
  { key: 'projects', label: 'Projects', href: '/projects', zone: 'projects' },
  { key: 'agents', label: 'Agents', href: '/agents', zone: 'agents' },
  { key: 'anu', label: 'ANU Live', href: '/anu' },
  { key: 'knowledge', label: 'Knowledge', href: '/knowledge', zone: 'knowledge' },
];

export const secondaryNav: NavItem[] = [
  { key: 'publications', label: 'Publications', href: '/publications', zone: 'archive' },
  { key: 'observatory', label: 'Observatory', href: '/observatory', zone: 'observatory' },
  { key: 'about', label: 'About', href: '/about' },
  { key: 'contact', label: 'Contact', href: '/contact', zone: 'gateway' },
];

export const allNav: NavItem[] = [...primaryNav, ...secondaryNav];
